export default __webpack_public_path__ + "static/media/minff-text.21df4bb2.png";